import * as itineraryRepo from "../repo/itineraryRepo";

/** PDF 专用页面的数据运行时，隔离页面与 repo/service 实现。 */
export const itineraryPdfRuntime = {
  async loadPrivate(itineraryId: string) {
    return (await itineraryRepo.getReadonlyPreview(itineraryId, true)).itinerary;
  },
  loadPublic(token: string) {
    return itineraryRepo.getPublicItinerary(token);
  },
};
